// extracted by mini-css-extract-plugin
module.exports = {"BasicInformationContainer":"BasicInformationContainer_BasicInformationContainer__2mZdG"};